import type { Route } from 'next';

import { Link } from '#components/Link/Link';

import styles from './ArticleModuleTeaser.module.scss';

const categoryPaths: Record<string, Route> = {
	Kultur: '/kultur,QXAPqxI' as Route,
	Netzwelt: '/netzwelt,QXAPuSB' as Route,
	Sport: '/sport,QXAPvmL' as Route,
	Wirtschaft: '/wirtschaft,QXAPwyN' as Route,
	Wissen: '/wissen,QXAPyRp' as Route,
};

/**
 * Returns a JSX element representing the category URL for the given page title.
 *
 * @param {string} pageTitle - The title of the page.
 * @return {JSX.Element | null} A JSX element representing the category URL, or null if the URL is not found.
 */
export function getCategoryURL(pageTitle: string) {
	const url = categoryPaths[pageTitle];

	return url ? (
		<>
			<span className={styles.breadcrumbArrow}>{'>'}</span>{' '}
			<Link href={url} className="body6 outline-inside">
				{pageTitle}
			</Link>{' '}
		</>
	) : null;
}

/**
 * Retrieves the category path for a given page title from the `categoryPaths` object.
 *
 * @param {string} pageTitle - The title of the page.
 * @return {string | null} The category path for the given page title, or `null` if the path is not found.
 */
export function getCategoryPath(pageTitle: string) {
	return categoryPaths[pageTitle] || null;
}
